import "./LocalSeoConsultantStokeOnTrent.module.css";
import Header from "@/reusable_sections/Header";
import Sectors from "./sections/Sectors";
import Consultant from "./sections/Consultant";
import Localhero from "./sections/Localhero";
import Services from "./sections/Services";
import Process from "./sections/Process";
import CaseImpact from "./sections/CaseImpact";
import Localseofaq from "./sections/Localseofaq";
import Stokemarket from "./sections/Stokemarket";
import Consultation from "./sections/Consultation";
import StokeAnalysis from "./sections/StokeAnalysis";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantStokeOnTrentPage() {
  return <div>
      <Header />
      <Sectors />
      <Consultant />
      <Localhero />
      <Services />
      <Process />
      <CaseImpact />
      <Localseofaq />
      <Stokemarket />
      <Consultation />
      <StokeAnalysis />
      <Footer />
    </div>;
}